import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, from,throwError  } from 'rxjs';
import { environment } from '../../environments/environment';

import { NgxSpinnerService } from 'ngx-spinner';
import { catchError, map } from 'rxjs/operators';
import  'rxjs/add/observable/throw';
import  'rxjs/add/operator/catch';
import { HeaderServiceService } from './header-service.service';


@Injectable({
  providedIn: 'root'
})
export class DataService {

  baseURL: string = environment.apiEndpoint;
  
  constructor(private http: HttpClient, private ngxSpinnerService: NgxSpinnerService,
    private header:HeaderServiceService) { }

  getData(servicePath: string): Observable<any> {
    let headers = this.header.getContacts();
    const httpOptions = { headers: headers };
    return this.http.get<any>(this.baseURL + servicePath,httpOptions).pipe(catchError(this.handleError))
  }
  
  postData(servicePath: string, data: any) {
    let headers = this.header.getContacts();
    const httpOptions = { headers: headers };
    return this.http.post(this.baseURL + servicePath, data,httpOptions).pipe(catchError(this.handleError));
  }
  putData(servicePath: string, data: any) {
    let headers = this.header.getContacts();
    const httpOptions = { headers: headers };
    return this.http.put(this.baseURL + servicePath, data,httpOptions).pipe(catchError(this.handleError));
  }

  patchData(servicePath: string, data: any) {
    let headers = this.header.getContacts();
    const httpOptions = { headers: headers };
    return this.http.patch(this.baseURL + servicePath, data,httpOptions ).pipe(catchError(this.handleError));
  }

  private handleError(error:HttpErrorResponse){
    return Observable.throw(error.message || "Server Error")
  }
}
